<template>
	<section class="tender-news" aria-label="国械标讯">
		<div class="tender-header">
			<img class="tender-header-img" src="/staticSeo/images/guoxie_biaoxun.png" alt="国械标讯" />
			<a class="tender-more-link" href="#" rel="nofollow" aria-label="国械标讯更多" @click.prevent="handleClickMore"></a>
		</div>

		<van-swipe
			v-if="list.length"
			ref="swipeRef"
			class="tender-swipe"
			:autoplay="autoplay"
			:duration="500"
			:loop="totalDots > 1"
			:show-indicators="false"
			@change="onSwipeChange"
		>
			<van-swipe-item v-for="(page, pageIndex) in pages" :key="pageIndex">
				<ul class="list-col">
					<li v-for="(item, index) in page" :key="item.contentId || `${pageIndex}-${index}`" class="list-item-wrap">
						<a href="#" rel="nofollow" class="list-item" @click.prevent="handleItemClick(item)">
							<div class="list-item-main">
								<ExpandableText customClass="list-item-title" :enableButton="false" :line="1" :dt="item.name" />
								<span class="list-item-time">{{ item.publishDate }}</span>
							</div>
							<i class="iconfont icon-gongneng_xiangyou-37 list-item-arrow"></i>
						</a>
					</li>
				</ul>
			</van-swipe-item>
		</van-swipe>

		<div v-else class="tender-notice-empty">
			<img src="/staticSeo/images/no-data-new.png" alt="暂无标讯数据" />
		</div>

		<div v-if="totalDots > 1" class="pagination-dots">
			<button
				v-for="index in totalDots"
				:key="index"
				type="button"
				class="dot-wrapper"
				:aria-label="`第${index}页`"
				@click.stop="goToSlide(index - 1)"
			>
				<span class="dot" :class="{ active: currentIndex === index - 1 }"></span>
			</button>
		</div>
	</section>
</template>

<script setup>
import { computed, ref } from 'vue';
import ExpandableText from '@/components/ExpandableText.vue';

const PAGE_SIZE = 5;
const AUTOPLAY_DELAY = 5000;

const props = defineProps({
	list: {
		type: Array,
		default: () => [],
	},
});

const list = computed(() => props.list || []);

const emit = defineEmits(['clickMore', 'toDetail']);

const swipeRef = ref(null);
const currentIndex = ref(0);

const pages = computed(() => {
	const result = [];
	for (let i = 0; i < list.value.length; i += PAGE_SIZE) {
		result.push(list.value.slice(i, i + PAGE_SIZE));
	}
	return result;
});

const totalDots = computed(() => pages.value.length);
const autoplay = computed(() => (totalDots.value > 1 ? AUTOPLAY_DELAY : 0));

const onSwipeChange = index => {
	currentIndex.value = index;
};

const goToSlide = index => {
	swipeRef.value?.swipeTo?.(index);
	currentIndex.value = index;
};

const handleClickMore = () => {
	emit('clickMore');
};

const handleItemClick = item => {
	emit('toDetail', item);
};
</script>

<style scoped lang="scss">
.tender-news {
	margin: 0 8px 8px;
	padding: 12px 12px 8px;
	background: #fff;
	border-radius: 5px;
}

.tender-header {
	position: relative;
	width: 100%;
	margin-bottom: 8px;

	.tender-header-img {
		display: block;
		width: 100%;
		height: auto;
	}

	.tender-more-link {
		position: absolute;
		top: 0;
		right: 0;
		width: 22%;
		height: 100%;
	}
}

.tender-notice-empty {
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 120px;
	padding: 8px 0 12px;

	img {
		width: 160px;
		height: auto;
	}
}

.list-col {
	width: 100%;
	margin: 0;
	padding: 0;
	list-style: none;

	li + li {
		border-top: 1px solid #f0f0f0;
	}
}

.list-item-wrap {
	position: relative;
}

.list-item {
	position: relative;
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 8px 0;
	text-decoration: none;
	color: inherit;
}

.list-item-main {
	flex: 1;
	min-width: 0;

	:deep(.expandable-text-container),
	:deep(.hide-container) {
		min-width: 0;
	}

	:deep(.list-item-title) {
		width: 100%;
		font-size: 13px;
		font-weight: 600;
		line-height: 18px;
		color: #333;
	}
}

.list-item-time {
	display: block;
	margin-top: 2px;
	font-size: 11px;
	line-height: 16px;
	color: #999;
}

.list-item-arrow {
	flex-shrink: 0;
	font-size: 12px;
	color: #c0c4cc;
}

.pagination-dots {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;
	padding: 12px 0 4px;

	.dot-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 16px;
		padding: 0;
		border: none;
		background: transparent;
		cursor: pointer;
	}

	.dot {
		display: block;
		width: 6px;
		height: 4px;
		border-radius: 10px;
		background: #c8cdd4;
		transition:
			width 0.3s,
			background-color 0.3s;

		&.active {
			width: 12px;
			background: #455bd9;
		}
	}
}
</style>
